import { KEY_VALUE_SEPARATOR } from '../../constants/DevicePluginGenerator';
import { splitStringOnFirst } from './splitStringOnFirst';

/**
 * Parses a decoded HTTP Basic Auth credentials string "username:password" into its parts,
 * splitting on the FIRST colon only. Per RFC 7617 the user-id cannot contain a colon, while
 * the password may, so everything after the first colon is treated as the password
 * (e.g. "user:pa:ss" → { username: "user", password: "pa:ss" }).
 * @param {string} decodedCredentials - decoded credentials, e.g. "user:pa:ss"
 * @returns {{ username: string, password: string }} - e.g. { username: "user", password: "pa:ss" }
 */
export const parseBasicCredentials = (decodedCredentials = '') => {
    const { before, after } = splitStringOnFirst(decodedCredentials, KEY_VALUE_SEPARATOR);

    return { username: before, password: after };
};
